"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.soil_type_label_fn = void 0;
const Options_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/options/Options"));
function soil_type_label_fn(key) {
    const soil_types = Options_1.default.soil_types.all();
    const soil_type = soil_types.find(st => (st.id + '') === key);
    if (soil_type)
        return soil_type.name;
    return key;
}
exports.soil_type_label_fn = soil_type_label_fn;
